import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb } from '../../components'
import { Form, PartnerSelect } from './components'

const routes = [
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Organization Profile',
    route: '/dashboard/profile'
  },
  {
    name: 'Partners',
    route: '/dashboard/profile/partners'
  }
]

const DashboardPartnersForm = () => {
  const [type, setType] = React.useState('select')

  return (
    <DashboardLayout title="Add New / Edit Partner">
      <div className="hidden xl:block">
        <Breadcrumb routes={routes}/>
        <h1 className="text-4xl font-primary font-bold">
          Add New / Edit Partner
        </h1>
        <hr className="mt-5 mb-8"/>
      </div>
      <div className="xl:w-2/3">
        { type === 'form' && <Form />}
        { type === 'select' && <PartnerSelect setType={setType}/>}
      </div>
    </DashboardLayout>
  )
}

export { DashboardPartnersForm }
